










































































































































































































































































import $ from 'jquery';
import {
    EventBus,
    hasElements,
    TypeEventBus,
    sortObjectByPropertyName,
    checkIfIDExistsInArray,
    getUniqueId,
    formatDate,
    getCurrentTimestamp
} from '../../core/utils';
import { Destroyed } from '../../core/decorators';
import { Component, Prop, Mixins, Vue, Watch, Emit } from 'vue-property-decorator';
import { PRIVILEGE_KEYS, PRIVILEGE_TYPES } from '../../core/utils/privileges';
import ConfirmAction from '../../core/components/ConfirmAction.vue';
import SetParameterValue from './SetParameterValue.vue';
import {
    MsgBox,
    Combobox,
    PlusEyeButtons,
    Breadcrums,
    CloseConfirmationModal,
    LoadingDialog
} from '../../core/components';
import Button from '../../core/components/Button.vue';
import {
    AuthStoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    StoreHelper,
    NotificationStoreHelper
} from '../../core/mixins';
import multiselect from 'vue-multiselect';
import Axios from 'axios';
import Loading from 'vue-loading-overlay';
import { config } from 'rxjs';
import moment from 'moment';
import { SettingsService } from '../api/SettingsService';
import { dateTypes } from '../../../features/core/models';

@Component({
    components: {
        Loading,
        Combobox,
        Button,
        ConfirmAction,
        SetParameterValue
    }
})
export default class VehiclesActions extends Mixins(
    AuthStoreHelper,
    StoreHelper,
    RootStoreHelper,
    CompanyStoreHelper,
    NotificationStoreHelper
) {
   @Prop({default: []}) vehiclesList: string[];
   @Prop({default: ''}) selectedVehiclesNames: string;
   @Prop({default: false}) loadingDetail: boolean;
   @Prop({default: false}) visibleActions: boolean;
   @Prop({default: false}) loadingFtpData: boolean;
   @Prop({default: false}) multipleVehicles: boolean;
   @Prop({default: false}) vehicleHasActiveNorm: boolean;
   @Prop({default: null}) activationVehicleStatus: number | null;
   @Prop({default: ''}) activationVehicleStatusMsg: string;
   @Prop({ default: () => {}}) vehicleProperties: object;
   @Prop({ default: false}) mtopRegid: boolean;
   visibleActiveConfirmAction: boolean = false;
   deactivateNormConfirmMessageBody: string = '';
   visibleDeactivateNormConfirmation: boolean = false;
   visibleModalDeactivateAlerts: boolean = false;
   pendingVariables: boolean = false;
   pendingNorm: boolean = false;
   deactivatingAlerts: boolean = false;
   visibleSetParameterValueModal: boolean = false;
   showMtop: boolean = false;
   noVehiclesSelectedAlert: string = 'No hay ningún vehículo seleccionado';
   singleVehicleConfirmMessage: string = '¿Está seguro que desea activar este vehículo? se enviará un SMS.'
   multipleVehicleConfirmMessage: string = '¿Está seguro que desea activar los vehículos seleccionados? se enviará un SMS.'
   deactivateNormMessageBody: string = '¿Está seguro que desea desactivar la Norma a éstos vehículos?'
   deactivateAlertsConfirmMessage: string = 'Ésta acción desactivará <b>TODAS</b> las alertas de estos vehículos:<br>'
   deactivateAlertsConfirmMessageBody: string = ''
   activationMtopStatusMsg: string = '';
   buttonsStyles: string = 'text-capitalize body-2 full-width';

   showSetParameterValueModal(){
    this.visibilitySetParameterValueModal(true);
   }

   visibilitySetParameterValueModal(value){
    this.visibleSetParameterValueModal = value;
   }

   visibilityActiveConfirmation(value) {
        this.visibleActiveConfirmAction = value;
    }
   visibilityDeactivateNormConfirmation(value) {
        this.visibleDeactivateNormConfirmation = value;
    }
   visibilityDeactivateAlertsConfirmation(value) {
        this.visibleModalDeactivateAlerts = value;
    }

   @Emit()
   updateParameterValueList(){}
   
   @Emit()
   deactivateConfigurationsSuccess(){}

   @Emit()
   deactivateNormsSuccess(vehiclesIds: string[]){}

   @Emit()
   confirmConfigurationsSuccess(){}

   @Emit()
   reloadVehicleDetail(){}

   @Emit()
   changeMachineAction(){}

   @Emit()
   clickSetBroadcasts(){}

   @Emit()
   clickSetFtp(){}
   
   @Emit()
   updateVehicleStatus(activationStatus, msg){}
   
   @Emit()
   toggleMtopRegId(value: boolean | null){}

   @Emit()
   deactivateAlertsSuccess(vehiclesIds: string[], acknowledgeTime: string | null){}

   getVehiclesToSubmit(){
    return {
        vehicle_ids: this.vehiclesList
    }
   }
    
   resetLastValues(){
        SettingsService.resetLastValues(
            this.getVehiclesToSubmit()
        ).then((res) => {
            this.$_successPatchRecipients(res.message);
        }).catch((err) => {
            this.$_showHistoricalError(err);
        })
   }
   
   getVehiclesNames(){
    return ' <b>' + this.selectedVehiclesNames + '</b>'
   }

    deactivateNormConsequences(){
        return '<br><br> Impacto que tendrá esta acción:<br> <li>Los vehículos no tendrán ninguna norma activa</li> <li>Se desactivarán todas las Variables</li> <li>Se desactivarán todas las Alarmas</li> <li>No podrá activar variables (Se conservan los Grupos de variables)</li> <li>No podrá setear parameter values</li>'
    }

   showDeactivateNormConfirmation(){
    this.deactivateNormConfirmMessageBody = this.deactivateNormMessageBody + this.getVehiclesNames() + this.deactivateNormConsequences();
    this.visibilityDeactivateNormConfirmation(true)
   }

   showModalDeactivateAlerts(){
    this.deactivateAlertsConfirmMessageBody = this.deactivateAlertsConfirmMessage + this.getVehiclesNames() + '<br><br><b>A tener en cuenta:</b> Si alguna alerta se vuelve a repetir se volverá a activar<br><br>¿Está seguro que desea continuar?';
    this.visibilityDeactivateAlertsConfirmation(true)
   }

   deactivateNorm(){
    this.pendingNorm = true;
    let data = {
        vehicle_ids: this.vehiclesList
    }
        SettingsService.deactivateVehicleNorm(
            data
        ).then((res) => {
             this.pendingNorm = false;
             this.$_successPatchRecipients(res.message);
             this.deactivateNormsSuccess(this.vehiclesList);
        }).catch((err) => {
            this.$_catchLoadingDialog({
                response: err.response.data || {},
                alternative_msg: 'Falló Desactivar Norma'
            });
        })
   }

   deactivateConfigurations(){
        this.pendingVariables = true;
         SettingsService.deactivateConfigurations(
            this.getVehiclesToSubmit()
         ).then((response) => {
            this.deactivateConfigurationsSuccess();
            this.pendingVariables = false;
            this.$_successPatchRecipients(response.message);
         }).catch((e) => {
            this.pendingVariables = false;
            this.$_showHistoricalError(e);
         })
        
   }

   confirmConfigurations(){
        SettingsService.confirmConfigurations(
           this.getVehiclesToSubmit()
        ).then((response) => {
            this.confirmConfigurationsSuccess();
            this.$_successPatchRecipients(response.message);
         }).catch((e) => {
            this.$_showHistoricalError(e);
         })
   }

   alarmSistrac(){
    SettingsService.alarmSistrac(
        this.getVehiclesToSubmit()
    ).then((response) => {
        this.$_successPatchRecipients(response.message);
    }).catch((e) => {
        this.$_showHistoricalError(e);
    })
   }

   resendConfigurations(){
    SettingsService.resendConfigurations(
        this.getVehiclesToSubmit()
    ).then((response) => {
        this.$_successPatchRecipients(response.message);
    }).catch((e) => {
        this.$_showHistoricalError(e);
    })
   }

   get existVehiclesToUpdate(){
    return this.vehiclesList.length == 0 ? false : true
   }

   get getActivationConfirmMessage(){
    return this.multipleVehicles ? this.multipleVehicleConfirmMessage : this.singleVehicleConfirmMessage
   }
   
   get getActivationStatusColor() {
        if (this.activationVehicleStatus == 0) {
            return 'red--text';
        }
        if (this.activationVehicleStatus == 1) {
            return 'yellow--text';
        }
        if (this.activationVehicleStatus == 2) {
            return 'green--text';
        }

        return '';
    }

    get activationStatusClass() {
        if (this.mtopRegid) {
            return 'black--text';
        } else {
            return 'red--text';
        }
    }

    get getActivationStatusColorForMtopButton() {
        if (this.mtopRegid) {
            return 'error';
        } else {
            return 'success';
        }
    }

    closeDeactivateAlertsConfirmationDialog(confirm: boolean) {
        if (confirm) {
            this.deactivateAlerts();
        }
        this.visibilityDeactivateAlertsConfirmation(false)
    }

    deactivateAlerts(){
        this.deactivatingAlerts = true;
        let vehiclesToDeactivate = this.vehiclesList;
        SettingsService.deactivateAlertsToVehicles(
            {
                vehicle_ids: vehiclesToDeactivate
            }
        ).then((res) => {
                this.deactivatingAlerts  = false;
                let acknowledgeTime = res.acknowledge_date;
                this.$_successPatchRecipients(res.message);
                this.deactivateAlertsSuccess(vehiclesToDeactivate, acknowledgeTime);
        }).catch((err) => {
            this.deactivatingAlerts  = false;
            this.$_catchLoadingDialog({
                response: err.response.data || {},
                alternative_msg: 'No se pudieron desactivar las alertas'
            });
        })
    }
    closeDeactivateNormConfirmationDialog(confirm: boolean) {
        if (confirm) {
            this.deactivateNorm();
        }
        this.visibilityDeactivateNormConfirmation(false)
    }
    closeActiveConfirmationDialog(confirm: boolean) {
        if (confirm) {
             SettingsService.activateVehicle(
                this.getVehiclesToSubmit()
            ).then((response) => {
                this.updateVehicleStatus(response.activation_status, this.vehicleProperties['all_activation_status'][response['activation_status']]);
                this.$_successPatchRecipients(response.message);
            }).catch((e) => {
                this.$_showHistoricalError(e);
            })
        }
        this.visibilityActiveConfirmation(false)
    }

    toggleMtop() {
        if (this.mtopRegid) {
            this.disableMtop();
        } else {
            this.activateMtop();
        }
    }

    activateMtop() {
        SettingsService.activateMtop(
            { id: this.vehiclesList[0]}
        ).then((response) => {
            this.toggleMtopRegId(response.mtop_regid)
            this.activationMtopStatusMsg = response.mtop_regid;
            this.$_successPatchRecipients(response.message);
        }).catch((e) => {
            this.$_showHistoricalError(e);
        })
    }

    async disableMtop() {
        SettingsService.disableMtop(
            { id: this.vehiclesList[0]}
        ).then((response) => {
            this.toggleMtopRegId(false)
            this.activationMtopStatusMsg = '';
            this.$_successPatchRecipients(response.message);
        }).catch((e) => {
            this.$_showHistoricalError(e);
        })
    }

}
